// reducer.js
import produce from 'immer';

import { SET_SUPERVISOR } from '../actions/caseListingVar';

const initialState: IMountStore = {
  isSupervisor: null,
};

export default (state: IMountStore = initialState, action: any) =>
  produce(state, (draftState: IMountStore) => {
    switch (action.type) {
      case SET_SUPERVISOR:
        draftState.isSupervisor = action.payload;

        return;
    }
  });
